import RejectionReasonBanner from './RejectionReasonBanner.component';

export default RejectionReasonBanner;